import { render, staticRenderFns } from "./OpportunityFeedbackForm.vue?vue&type=template&id=2d61b079"
import script from "./OpportunityFeedbackForm.vue?vue&type=script&lang=js"
export * from "./OpportunityFeedbackForm.vue?vue&type=script&lang=js"
import style0 from "./OpportunityFeedbackForm.vue?vue&type=style&index=0&id=2d61b079&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d61b079')) {
      api.createRecord('2d61b079', component.options)
    } else {
      api.reload('2d61b079', component.options)
    }
    module.hot.accept("./OpportunityFeedbackForm.vue?vue&type=template&id=2d61b079", function () {
      api.rerender('2d61b079', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Opportunity/Feedback/OpportunityFeedbackForm.vue"
export default component.exports